var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.98,
    height: 44.231,
    viewBox: "0 0 44.98 44.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.484 38.485)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.499,
    cy: 1.499,
    r: 1.499,
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.999 39.235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.739,380H32.75a.75.75,0,0,0,0,1.5h23.99a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-32 -380)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.987 39.235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.748,380h-3a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-320 -380)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.484 27.99)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.499,
    cy: 1.499,
    r: 1.499,
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.999 28.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.739,268H32.75a.75.75,0,0,0,0,1.5h23.99a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-32 -268)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.987 28.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.748,268h-3a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-320 -268)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.484 17.494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.499,
    cy: 1.499,
    r: 1.499,
    fill: "#f90000"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.999 18.244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.739,156H32.75a.75.75,0,1,0,0,1.5h23.99a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-32 -156)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.987 18.244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.748,156h-3a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-320 -156)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.731,13a2.249,2.249,0,0,0,2.249-2.249v-4.5A2.249,2.249,0,0,0,42.731,4H2.249A2.249,2.249,0,0,0,0,6.249v4.5A2.249,2.249,0,0,0,2.249,13H3v1.5h-.75A2.249,2.249,0,0,0,0,16.744v4.5a2.249,2.249,0,0,0,2.249,2.249H32.236v1.5H2.249A2.249,2.249,0,0,0,0,27.24v4.5a2.249,2.249,0,0,0,2.249,2.249H3v1.5h-.75A2.249,2.249,0,0,0,0,37.735v4.5a2.249,2.249,0,0,0,2.249,2.249H32.236v2.249H.75a.75.75,0,0,0,0,1.5H44.231a.75.75,0,1,0,0-1.5h-1.5V44.482a2.249,2.249,0,0,0,2.249-2.249v-4.5a2.249,2.249,0,0,0-2.249-2.249H13.494v-1.5H42.731a2.249,2.249,0,0,0,2.249-2.249v-4.5a2.249,2.249,0,0,0-2.249-2.249v-1.5a2.249,2.249,0,0,0,2.249-2.249v-4.5A2.249,2.249,0,0,0,42.731,14.5H13.494V13Zm-7.5,33.735h-1.5V44.482h1.5Zm3,0h-1.5V44.482h1.5Zm3,0h-1.5V44.482h1.5Zm1.5-9.746a.75.75,0,0,1,.75.75v4.5a.75.75,0,0,1-.75.75H2.249a.75.75,0,0,1-.75-.75v-4.5a.75.75,0,0,1,.75-.75ZM4.5,35.486v-1.5H6v1.5Zm3,0v-1.5H9v1.5Zm3,0v-1.5h1.5v1.5ZM43.481,27.24v4.5a.75.75,0,0,1-.75.75H2.249a.75.75,0,0,1-.75-.75v-4.5a.75.75,0,0,1,.75-.75H42.731A.75.75,0,0,1,43.481,27.24Zm-9.746-2.249v-1.5h1.5v1.5Zm3,0v-1.5h1.5v1.5Zm3,0v-1.5h1.5v1.5Zm3-9a.75.75,0,0,1,.75.75v4.5a.75.75,0,0,1-.75.75H2.249a.75.75,0,0,1-.75-.75v-4.5a.75.75,0,0,1,.75-.75ZM4.5,14.5V13H6v1.5Zm3,0V13H9v1.5Zm3,0V13h1.5v1.5Zm-8.246-3a.75.75,0,0,1-.75-.75v-4.5a.75.75,0,0,1,.75-.75H42.731a.75.75,0,0,1,.75.75v4.5a.75.75,0,0,1-.75.75Z",
    transform: "translate(0 -4)",
    fill: "#f90000"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.484 6.999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.499,
    cy: 1.499,
    r: 1.499,
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.999 7.748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.739,44H32.75a.75.75,0,1,0,0,1.5h23.99a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-32 -44)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.987 7.748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.748,44h-3a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-320 -44)",
    fill: "#f90000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCenter);
export default __webpack_public_path__ + "static/media/data-center.04bb5b06c478bca2ed713e59ed0271b6.svg";
export { ForwardRef as ReactComponent };